// extracted by mini-css-extract-plugin
module.exports = {"changePassword":"ChangePassword_changePassword__2XUis","ContainerInput":"ChangePassword_ContainerInput__2S154","textPasswordChange":"ChangePassword_textPasswordChange__hKaIf"};